<mat-form-field [class]="inputClass">
  <mat-label>{{ label }}</mat-label>

  <mat-select [multiple]="multiple"
    [disabled]="disabled"
    [errorStateMatcher]="errorStateMatcher"
    [placeholder]="placeholder"
    [compareWith]="compareFn"
    [(ngModel)]="value"
    (selectionChange)="onSelect($event.value)"
    (blur)="onTouched()">

    @if (options) {
      <!-- Group mode -->
      @if (groupBy) {
        @if (hasEmptyOption) {
          <mat-option [value]="false">{{emptyOptionLabel}}</mat-option>
        }
        @for (groupName of groupedOptions.keys; track groupName) {
          <mat-optgroup [label]="groupName">
            @for (bankAccount of groupedOptions.get(groupName); track bankAccount) {
              <mat-option [value]="bankAccount">
                {{bankAccount.accountName}}
              </mat-option>
            }
          </mat-optgroup>
        }
      }
      <!-- List mode -->
      @if (!groupBy) {
        @if (hasEmptyOption) {
          <mat-option [value]="false">{{emptyOptionLabel}}</mat-option>
        }
        @for (bankAccount of options; track bankAccount) {
          <mat-option [value]="bankAccount">
            {{bankAccount.accountName}}
          </mat-option>
        }
      }
      <!-- Empty list -->
      @if (!options.length) {
        <mat-option [value]="false" [disabled]="true">
          {{emptyMessage}}
        </mat-option>
      }
      <!-- Add account button-->
      @if (canAdd) {
        <mat-option [routerLink]="['/client/bank-feeds']" class="c-primary">
          <i class="icon icon-plus ic-primary"></i>
          Add bank account
        </mat-option>
      }
    }

  </mat-select>

  <div matSuffix>
    @if (isLoading) {
      <app-preloader [type]="preloaderTypes.ICON" [size]="20"></app-preloader>
    }
  </div>

  <!-- Show control errors -->
  <mat-error>
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  </mat-error>
</mat-form-field>
